import { FC, SVGProps } from 'react';
import Apple from '../../assets/class-icons/apple.svg?react';
import AppleSimplified from '../../assets/class-icons/apple-simplified.svg?react';
import Bag from '../../assets/class-icons/bag.svg?react';
import Brain from '../../assets/class-icons/brain.svg?react';
import Site from '../../assets/class-icons/site.svg?react';
import MultiClass from '../../assets/class-icons/multi-class.svg?react';
import Calculator from '../../assets/class-icons/calculator.svg?react';
import Cube from '../../assets/class-icons/cube.svg?react';
import Heart from '../../assets/class-icons/heart.svg?react';
import JuiceBoxApple from '../../assets/class-icons/juice-box-apple.svg?react';
import JuiceBoxOrange from '../../assets/class-icons/juice-box-orange.svg?react';
import Muscles from '../../assets/class-icons/muscles.svg?react';
import Notebook from '../../assets/class-icons/notebook.svg?react';
import Pencil from '../../assets/class-icons/pencil.svg?react';
import Plus from '../../assets/class-icons/plus.svg?react';
import Ruler from '../../assets/class-icons/ruler.svg?react';
import Scissors from '../../assets/class-icons/scissors.svg?react';
import Shapes from '../../assets/class-icons/shapes.svg?react';
import Star from '../../assets/class-icons/star.svg?react';

export type ClassIconComponent = FC<SVGProps<SVGSVGElement>>;

export const DEFAULT_CLASS_ICON = 'apple-simplified';

export const SITE_ICON = 'site';

export const MULTI_CLASS_ICON = 'multi-class';

const PLACEHOLDER_ICONS = [DEFAULT_CLASS_ICON, SITE_ICON, MULTI_CLASS_ICON];

const CLASS_ICONS: Record<string, ClassIconComponent> = {
  pencil: Pencil,
  apple: Apple,
  'apple-simplified': AppleSimplified,
  'juice-box-orange': JuiceBoxOrange,
  'juice-box-apple': JuiceBoxApple,
  brain: Brain,
  bag: Bag,
  cube: Cube,
  notebook: Notebook,
  plus: Plus,
  calculator: Calculator,
  muscles: Muscles,
  scissors: Scissors,
  heart: Heart,
  ruler: Ruler,
  star: Star,
  shapes: Shapes,
  site: Site,
  'multi-class': MultiClass,
};

export const CLASS_ICON_NAMES: string[] = Object.keys(CLASS_ICONS).filter(name => !PLACEHOLDER_ICONS.includes(name));

export const ClassIcon = (iconName?: string | null): ClassIconComponent =>
  CLASS_ICONS[iconName ?? ''] ?? CLASS_ICONS[DEFAULT_CLASS_ICON];
